import {http} from '@ebexco/core/src/services/http';
import {conf} from '@ebexco/core/src/services/conf';

import {getLocalTest, getStorage, removeTestStorage, ttl} from './utils/tests';
import {getCurrentPath} from './utils/location';
import {abTests, abTestStorageKey} from '../serverless/src/routes/experiments/constants';
import {arrayToMap} from '@ebexco/core/src/utils/arrays';

/**
 *
 */
export async function getAbTest() {
  const storage = getStorage();
  const {active: isActive = false, permitted, segments = []} = abTests;

  if (isActive) {
    const browserPath = getCurrentPath();

    if (!permitted || permitted.some((regex) => regex.test(browserPath))) {
      const segmentsMap = arrayToMap(segments);
      const cvlyab = getLocalTest(storage, abTestStorageKey);

      if (cvlyab.ts > Date.now() && segmentsMap[cvlyab.feature]) {
        return cvlyab.feature;
      }

      const {value} = await getSegmentValue();

      if (value) {
        storage[abTestStorageKey] = JSON.stringify({feature: value, ts: Date.now() + ttl});

        return value;
      }
    }
  } else {
    removeTestStorage(storage, abTestStorageKey);
  }
}

/**
 *
 */
async function getSegmentValue() {
  try {
    return await http.getJson(`${conf.baseApi}experiments/ab/`);
  } catch (err) {
    console.log(err, 'Error getting experiment details');

    return {};
  }
}
